module.exports = __webpack_public_path__ + "img/35.a240a96f.jpg";